module.exports = __webpack_public_path__ + "img/2.e40e0659.png";